export default __webpack_public_path__ + "static/media/nap.d04453ea.png";